import { Reveal } from "@/components/motion/Reveal";
import { Sparkles, Users, Shield, Target, Lightbulb, Handshake, RefreshCcw, TrendingUp, GitBranch, BadgeCheck } from "lucide-react";

const items = [
  ["Soluciones personalizadas", "Cada proyecto se diseña según el contexto, madurez y objetivos.", Sparkles],
  ["Experiencia sectorial", "Trabajamos en manufactura, alimentaria, tecnología, servicios y más.", Users],
  ["Metodologías prácticas", "Herramientas útiles, aplicables y fáciles de mantener.", Target],
  ["Acompañamiento cercano", "Trabajo colaborativo con los equipos responsables.", Handshake],
  ["Confidencialidad", "Protegemos la información sensible de cada organización.", Shield],
  ["Transferencia de conocimiento", "Formamos al equipo interno para dar continuidad.", Lightbulb],
  ["Enfoque en riesgos", "Priorizamos lo que aporta valor y mitiga amenazas reales.", GitBranch],
  ["Orientación a resultados", "Indicadores, evidencias y mejoras verificables.", TrendingUp],
  ["Mejora continua", "Ciclos PHVA sostenibles después de cada intervención.", RefreshCcw],
  ["Soporte post-certificación", "Acompañamiento antes, durante y después.", BadgeCheck],
];

export default function Benefits() {
  return (
    <section id="beneficios" className="relative py-24 md:py-36 border-t border-[#1A1A1A]/10" data-testid="benefits-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <div className="eyebrow mb-6">— 06 · Diferenciadores</div>
          <h2 className="display-2 max-w-4xl">¿Por qué elegir <em className="italic text-[#1B3B2B]">KB Consultoría</em>?</h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-[1px] bg-[#1A1A1A]/12 border border-[#1A1A1A]/12">
          {items.map(([title, desc, Icon], i) => (
            <Reveal key={title} delay={i * 0.04}>
              <div className="bg-[#F9F6F0] p-6 md:p-7 h-full hover:bg-[#EFEBE2] transition-colors" data-testid={`benefit-${i}`}>
                <div className="h-10 w-10 rounded-full border border-[#1A1A1A]/20 flex items-center justify-center">
                  <Icon className="w-4 h-4 text-[#1B3B2B]" strokeWidth={1.5} />
                </div>
                <h3 className="mt-5 font-serif text-xl leading-tight">{title}</h3>
                <p className="mt-2 text-xs text-[#4A4A4A] leading-relaxed">{desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
